import { Box, Typography } from '@mui/material';
import { gradients } from '../theme/colors';

// Page title in the brand gradient, so it sits in the theme in both modes.
// The gradient is clipped to the text, so the text has to be inline-block —
// a full-width block would only ever show the middle of the gradient.
const PageHeading = ({ children }: { children: React.ReactNode }) => (
  <Box sx={{ textAlign: 'center', mb: 3 }}>
    <Typography
      variant="h4"
      component="span"
      sx={{
        display: 'inline-block',
        fontWeight: 800,
        backgroundImage: gradients.primary,
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        color: 'transparent',
        // Descenders get clipped by background-clip without a little room
        lineHeight: 1.3,
      }}
    >
      {children}
    </Typography>
  </Box>
);

export default PageHeading;
